import config from 'config'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styles from './styles.module.scss'
import MainContent from '../MainContent'
import MemberSearchTextBox from '../MemberSearchTextBox'
import Spinner from 'srcReact/components/common2/Spinner'
import ReviewActionButton from 'srcReact/components/common2/ReviewActionButton'

const AwaitingReview = ({ searchText, setSearchText }) => {
  const { t } = useTranslation()

  const {
    moderationReport: { loading, moderation_data }
  } = useSelector((state) => state)

  return (
    <div className={styles.awaitingReviewWrapper}>
      <div className={styles.awaitingReviewTabs}>
        <MemberSearchTextBox searchText={searchText} setSearchText={setSearchText} />
        {moderation_data.item_needs_immediate_rewiew.count > 0 && (
          <ReviewActionButton
            iconName='flag-icon'
            text={t('moderationReport.immediateRewiewItem', {
              count: moderation_data.item_needs_immediate_rewiew.count,
              item:
                moderation_data.item_needs_immediate_rewiew.count > 1
                  ? t('moderationReport.items')
                  : t('moderationReport.item')
            })}
            color='red'
          />
        )}
      </div>
      {loading ? (
        <Spinner />
      ) : (
        moderation_data.posts &&
        moderation_data.posts.map((post, idx) => (
          <MainContent key={idx} postId={post.object_id} type='awaiting_review' post={post} />
        ))
      )}
    </div>
  )
}

export default AwaitingReview
